import { render, staticRenderFns } from "./CbsSelectNumber.vue?vue&type=template&id=2f836812&"
import script from "./CbsSelectNumber.vue?vue&type=script&lang=js&"
export * from "./CbsSelectNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports